var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('th',[_vm._v(" "+_vm._s(_vm.label)+" "),_vm._t("default")],2),_c('td',{staticClass:"text-right tabular-nums"},[(_vm.loading)?_c('b-spinner',{staticClass:"invoice-line-spinner"}):_vm._e(),_vm._v(" "+_vm._s(_vm._f("currency")(_vm.total))+" ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }